export class GridCode {
    static code: number = 0;
}


// WEBPACK FOOTER //
// ./node_modules/@rx/table/grid-code.static.class.ts